module.exports = __webpack_public_path__ + "media/ting.a0511608.wav";